// extracted by mini-css-extract-plugin
module.exports = {"arrow":"TrendIndicator_arrow__3Vdmn"};